import type { UnitIdMatchesFilterSnapshot } from "../../types/experiment";
import { Input } from "../ui/input";
import { TagInput } from "../Shared/TagInput";

interface Props {
  value: UnitIdMatchesFilterSnapshot;
  onChange: (value: UnitIdMatchesFilterSnapshot) => void;
}

export function UnitIdMatchesFilterSnapshotFilter({ value, onChange }: Props) {
  return (
    <div className="space-y-2">
      <div>
        <label className="text-[10px] text-overlay1 mb-1 block">Filter Snapshot Name</label>
        <Input
          value={value.filter_snapshot_name}
          onChange={(e) => onChange({ ...value, filter_snapshot_name: e.target.value })}
          placeholder="snapshot name"
          className="h-8 text-xs"
        />
      </div>
      <TagInput
        label="Target Filter Values"
        tags={value.target_filter_values}
        onChange={(target_filter_values) => onChange({ ...value, target_filter_values })}
        placeholder="filter value"
      />
    </div>
  );
}
